const Mode = {
    character: 0,
    tag: 1,
    whitespace: 2,
    entity: 3,
};

export default Mode;